module.exports = __webpack_public_path__ + "static/media/banner-home.3e63ae19.webp";